import React, { useContext } from 'react';
import { Text, TextVariant } from '@naf/text';
import { DowngradeContext } from '@pages/downgrade/context/DowngradeContext';
import * as S from './TextWithHouseholdMember.styles';

interface TextWithHouseholdMemberProps {
  value: {
    text: string;
  };
}

export const TextWithHouseholdMember = ({ value: { text } }: TextWithHouseholdMemberProps) => {
  const { householdMember } = useContext(DowngradeContext);

  return (
    <Text variant={TextVariant.ArticleText}>
      {text}{' '}
      <S.BoldText tag="span" variant={TextVariant.ArticleText}>
        {householdMember?.fullName}
      </S.BoldText>
      .
    </Text>
  );
};

export const TextWithHouseholdMemberSerializer =
  () =>
  ({ value }: TextWithHouseholdMemberProps) => <TextWithHouseholdMember value={value} />;

export { BoldText } from './TextWithHouseholdMember.styles';
